module.exports = __webpack_public_path__ + "static/media/corner-cirle-bg.1c518365.svg";